export default __webpack_public_path__ + "static/media/postnord.678d8014.jpg";